/**
 * Labels for Assign To field summary (batch names or employee names).
 */
export function resolveAssignToSelectionNames({
  isHr = false,
  selectedIds = [],
  collegeTemplates = [],
  employees = [],
}) {
  const selected = Array.isArray(selectedIds) ? selectedIds.map(String) : [];
  if (!selected.length) return [];

  if (isHr) {
    return collegeTemplates
      .filter((tpl) => {
        const ids = (tpl.student_ids || []).map(String);
        return ids.length > 0 && ids.every((id) => selected.includes(id));
      })
      .map((tpl) => tpl.name || tpl.template_name || '')
      .filter(Boolean);
  }

  return employees
    .filter((emp) => selected.includes(String(emp.id)))
    .map((emp) => emp.name)
    .filter(Boolean);
}
